// Method for escaping special characters in regex search expressions. Otherwise unterminated expression error is thrown
// All of these should be escaped: \ ^ $ * + ? . ( ) | { } [ ]
export default string => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
